<template>
  <div>
    <Breadcrumbs 
      :children="[
        {
          text: 'Ordenes recientes',
        }
      ]"/>

    <div class="card ml-15 mr-10">
      <div class="card-body">
        <div v-if="thereAreNoOrders">
          <h4 class="text-center">No hay ordenes</h4>
        </div>

        <div class="row">
          <div class="col-sm-7 mb-2">
            <input
              type="text"
              v-model="filter"
              class="form-control"
              placeholder="Filtrar por cliente, suplidor o número de orden"
            />
          </div>
        </div>

        <!-- Lista -->
        <div class="row">
          <div class="col-sm-12" id="order-list-container">

            <div v-if="isMobile" class="mobile-table list-group">
              <!-- TODO -->
              <div v-for="order in orders"
                :key="order.id" 
                class="list-group-item">
                <div class="row">
                  <div class="col-9 flex-col">
                    <span class="mobile-order-number">#{{ order.number }}</span>
                    <span class="mobile-order-client">{{ order.clientName }}</span>
                    <span class="mobile-order-branch-office">{{ order.branchOfficeName }}</span>
                  </div>
                  <div class="col-3 text-center flex-col" style="padding:0;">
                    <div class="text-center mobile-order-total">${{ order.total | money }}</div>
                    <div>
                      <div v-if="order.loading">
                        <i class="fa fa-spinner fa-spin"></i>
                      </div>
                      <div v-else>
                        <a
                          title="Ver"
                          @click="showOrderDetails(order)"
                          href="#"
                          class="btn btn-info btn-sm"
                        >
                          Ver
                        </a>                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <table class="table" id="list">
                <thead class="thead-light">
                  <tr>
                    <th>No.</th>
                    <th>Cliente</th>
                    <th>Provincia-Zona</th>
                    <th>Tipo</th>
                    <th>Fecha</th>
                    <th class="text-center">A pagar</th>
                    <th class="text-center">Suplidor</th>
                    <th class="text-center">Estado</th>
                    <th class="text-center">Tipo Pago</th>
                    <th class="text-center">Fecha Pago</th>
                    <th class="text-center">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in orders" :key="order.id" v-show="orderCanBeShown(order)">
                    <td>
                      <div style="font-size: 18px; font-weight: 600;">{{ order.number }}</div>
                      <div style="font-size: 11px">{{ order.id }}</div>
                    </td>
                    <td>{{ order.clientName }}</td>
                    <td>{{ order.clientProvince || '' }}</td>
                    <td>{{ order.pickup ? 'Pickup' : 'Delivery' }}</td>
                    <td>{{ order.confirmationDate }}</td>
                    <td class="text-center">${{ order.total | money }}</td>
                    <td class="text-center">
                      {{ order.branchOfficeName }}
                    </td>
                    <td class="text-center">
                      <span class="badge badge-primary">Reciente</span>
                    </td>
                    <td>{{ order.paymentProvider }}</td>
                    <td class="text-center">
                      <span v-if="order.paidAt">{{ order.paidAt }}</span>
                      <span v-else class="badge badge-warning">Pendiente</span>
                    </td>
                    <td class="text-center">
                      <div v-if="order.loading">
                        <i class="fa fa-spinner fa-spin"></i>
                      </div>
                      <div v-else>
                        <a
                          title="Ver"
                          @click="showOrderDetails(order)"
                          href="#"
                          class="text-info font-larger"
                        >
                          <i class="fa fa-eye mr-1"></i>
                        </a>  
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="loading" class="text-center">
              <Loader />
            </div>

          </div>
        </div>

        <!-- *************** -->
        <!-- ORDER DETAIL MODAL -->
        <div
          class="modal fade"
          id="detail-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="roduct-modal"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header detail-modal-header">
                <div class="row" style="width: 100%;">
                  <div class="col-10">
                    <span style="font-size: large;">
                      <b>Número de orden: {{ currentOrder.invoice_number }}</b>
                    </span>
                  </div>
                  <div class="col-2">
                    <button
                      style="padding: 1rem 0 0 0 !important;"
                      class="close close-modal-custom"
                      @click="closeDetailModal()"
                    >
                      <span aria-hidden="true">
                        <i class="fa fa-close"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="modal-body">
                <div v-if="currentOrder.id != ''">
                  <OrderDetailModalContent
                    :key="currentOrder.id"
                    :currentOrder="currentOrder"
                    :orderProducts="orderProducts"
                  />
                </div>
              </div>
              <div v-if="$userIsAdmin()" class="modal-footer">
                <div class="row" style="width: 100%;">
                  <div class="col-sm-4 text-left">
                    <button :disabled="onRequest" @click="askToCancelOrder" class="btn btn-danger">Cancelar orden</button>
                  </div>
                  <div class="col-sm-8 text-right">
                    <button :disabled="onRequest || currentOrder.paidAt" @click="markAsPaid" class="btn main-bg mr-3">Confirmar pago</button>

                    <UpdateOrderStatusBtn 
                    :order_id="currentOrder.id" 
                    :branch_office_id="currentOrder.branch_office_id"
                    :user_id="currentOrder.user_id"
                    v-on:status-updated="onOrderStatusUpdate" />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- *************** -->

        <!-- *************** -->
        <!-- Order deliveries modal -->
        <div class="modal fade"
          id="drivers-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="drivers-modal-head"
          aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header detail-modal-header">
                <div class="row w100">
                  <div class="col-sm-10">
                    <h4 id="drivers-modal-head" class="m-0">Deliveries disponibles</h4>
                  </div>
                  <div class="col-sm-2">
                    <button
                      style="padding: 1rem 0 0 0 !important;"
                      class="close close-modal-custom"
                      @click="closeDriversModal()"
                    >
                      <span aria-hidden="true">
                        <i class="fa fa-close"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="modal-body">

                <div style="max-height:50vh;overflow-y:auto;font-weight:400;">
                  <table class="table">
                    <thead class="thead-light">
                      <tr>
                        <th colspan="2">Nombre</th>
                        <th>Teléfono</th>
                        <th>Estado</th>
                        <th class="text-center">Opciones</th>
                      </tr>  
                    </thead>
                    <tbody>
                      <tr v-for="x in orderDrivers" :key="x.id">
                        <td style="width:76px;"><img :src="x.photo || '/logo_blue.png'" class="driver-pic image-rounded" alt="Foto"></td>
                        <td>{{ x.name }}</td>
                        <td>{{ x.phone }}</td>
                        <td><i :class="`text-${x.statusClass}`">&#9679;</i> {{ x.statusText }}</td>
                        <td class="text-center">
                          <div v-if="x.orderIsAssigned">
                            <span>Asignado</span>
                          </div>
                          <div v-else>
                            <button class="btn btn-sm btn-primary">Asignar</button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
              <div class="modal-footer">
                <div class="row w100">
                  <div class="col-sm-12 text-right">
                    <button class="btn btn-default" @click="closeDriversModal">Cerrar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- *************** -->

      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import Breadcrumbs from "../components/Breadcrumbs";
import OrderDetailModalContent from "../components/OrderDetailModalContent";
import Loader from '../components/Loader'
import { CompanyService } from '../../services/CompanyService';
import { BranchOfficeService } from '../../services/BranchOfficeService';
import { DriverService } from '../../services/DriverService';
import Constants from '../../commons/Constants';
import { OrdersService } from '../../services/OrdersService';
import UpdateOrderStatusBtn from '../components/UpdateOrderStatusBtn.vue';

export default {
  components: { 
    Breadcrumbs, 
    OrderDetailModalContent,
    Loader,
    UpdateOrderStatusBtn
  },
  name: "Orders",
  data: function () {
    return {
      orders: [],
      companies: [],
      currentOrder: {
        id: "",
        name: "",
        phone: "",
        address: "",
        province: "",
        subTotal: 0,
        taxes: 0,
        total: 0,
        payment_type: "",
        transaction_id: "",
        payment_provider: "",
        branchOfficeId: "",
        number: "",
        appliedCoupon: "",
        shippingCost: "",
        totalInCoupon: "",
        userId: "",
        availableForDelivery: ''
      },
      orderProducts: [],
      loading: false,
      thereAreNoOrders: false,
      companyCurrency: "RD",
      onRequest: false,
      filter: "",
      company: "",
      branchOfficeService: new BranchOfficeService(),
      companyService: new CompanyService(),
      orderDrivers: [],
      driverService: new DriverService(),
      orderService: new OrdersService(),
      isMobile: false
    };
  },
  methods: {
    onOrderStatusUpdate({status, order_id}){
      console.log('onOrderStatusUpdate ', status, order_id);
      for(let i = 0; i < this.orders.length; i++){
        if(this.orders[i].id == order_id){
          this.orders[i].status = status;
          break;
        }
      }
    },
    closeDriversModal(){
      $('#drivers-modal').modal('hide');
    },
    async showOrderDrivers(order){
      const response = await this.driverService.getUsers(
        Constants.driverStatus.AVAILABLE,
        Constants.driverRoles.DRIVER 
      );
      this.orderDrivers = response.users;
      this.orderDrivers.forEach(x => {
        x.orderIsAssigned = x.orders.indexOf(order.id) !== -1;
      });
      $('#drivers-modal').modal('show');
    },
    async listenforNewOrders() {
      this.loading = true;
      this.orders = [];

      //Si es admin, se muestran las ordenes de todas las sucursales
      const companyToFilter = this.$store.getters.isComerce === true
        ? this.$store.getters.getCompany
        : '';

      this.branchOfficeService.listenForOrders(companyToFilter, (order) => {
        this.addOrderToList(order);
        if(this.loading){
          this.loading = false;
        }
        // this.showNotification(order.branchOfficeName, order.number);
      });

      //Esto es por si no hay ordenes el loading no se quede forever
      setTimeout(() => {
        if(this.loading){
          this.loading = false;
        }
      }, 2000);

    },
    addOrderToList(order){
      if(this.orders.find(x => x.id === order.id) !== undefined){
        this.orders.splice(
          this.orders.findIndex(x => x.id === order.id),
          1,
          order
        );
      }else{
        this.orders.push(order);
      }
    },
    orderCanBeShown(order) {
      return (
        this.filter == "" ||
        order.clientName.toLowerCase().includes(this.filter.toLowerCase()) ||
        order.branchOfficeName.toLowerCase().includes(this.filter.toLowerCase()) ||
        order.number.toString().toLowerCase().includes(this.filter.toLowerCase())
      );
    },
    async showOrderDetails(order) {
      order.loading = true;
      this.onRequest = true;
      this.orderProducts = [];

      try {
        const result = await this.branchOfficeService.getOrderDetail(
          order.branchOfficeId,
          order.id
        );

        if(result.ok){
          this.orderProducts = result.cart;
          this.currentOrder = Object.assign({}, result.orderData);
          const pointB = result.orderData.service_route.point_b;

          this.currentOrder.name = pointB.name;
          this.currentOrder.address = pointB.dir;
          this.currentOrder.phone = pointB.mobile_number;
          this.currentOrder.province = pointB.province;
          this.currentOrder.paidAt = order.paidAt;

          $("#detail-modal").modal("show");
        }else{
          this.$helpers.toast("Error al generar detalle", "error");
        }

      } catch (e) {
        console.log("ERROR showOrderDetails ", e);
        this.$helpers.toast("Error al generar detalle", "error");
      } finally {
        order.loading = false;
      }

      this.onRequest = false;
    },
    async reciveOrder() {

      const ok = await this.$helpers.confirm('Esta acción notificará al usuario de que su orden fue recibida');
      if(!ok){
        return;
      }

      this.onRequest = true;
      try {

        const res = await this.orderService.confirmOrderByCompany(
          this.currentOrder.branch_office_id,
          this.currentOrder.id,
        );
        if(!res.ok){
          throw new Error(res.message);
        }
        this.$helpers.message('Información', 'La orden ha sido marcada como recibida, para dar seguimiento favor dirigirse al historico.');

        this.orders = this.orders.filter((o) => o.id != this.currentOrder.id);
        this.showOrders = false;
        this.closeDetailModal();

      } catch (error) {
        console.log(error);
        this.$helpers.message('Error', error.message, 'error');
      }

      this.onRequest = false;
    },
    async markAsPaid(){
      this.onRequest = true;
      try {

        const res = await this.orderService.markOrderAsPaid(
          this.currentOrder.branch_office_id,
          this.currentOrder.id,
        );
        if(!res.ok){
          throw new Error(res.message);
        }
        this.$helpers.message('Información', 'Orden pagada correctamente');
        this.closeDetailModal();
        console.log('=res ', res);
        for (let index = 0; index < this.orders.length; index++) {
          const element = this.orders[index];
          if(this.orders[index].id === this.currentOrder.id){
            this.orders[index].paidAt = res.data.paid_at;
            break;
          }
        }

      } catch (error) {
        console.log(error);
        this.$helpers.message('Error', error.message, 'error');
      }

      this.onRequest = false;
    },
    closeDetailModal: function () {
      this.currentOrderCustomer = "";
      $("#detail-modal").modal("hide");
    },
    async askToCancelOrder() {
      const option = await Swal.fire({
        title: "Seleccione la razon de cancelacion",
        input: "select",
        inputOptions: [
          "El cliente canceló",
          "No hay stock",
        ],
        showCancelButton: true,
        confirmButtonColor: "#4279AF",
        cancelButtonColor: "#d33",
        cancelButtonText: '<i class="fa fa-close"></i> Cerrar',
        confirmButtonText: '<i class="fa fa-check"></i> Aceptar',
        backdrop: false,
        reverseButtons: true,
      });

      if(!option.value) return;
      
      const response = await this.branchOfficeService.cancelOrder(
        this.currentOrder.branch_office_id,
        this.currentOrder.id,
        option.value == 1 ? 'No hay stock' : 'El cliente canceló'
      );

      if(response.ok){
        this.$helpers.toast("Estado actualizado!");
        this.closeDetailModal();
        this.removeOrderFromList(this.currentOrder.id)
      }else{
        this.$helpers.message('Error', response.message, 'error');
      }
      
    },
    removeOrderFromList(id) {
      for (let i = 0; i < this.orders.length; i++) {
        if (this.orders[i].id === id) {
          this.orders.splice(i, 1);
        }
      }
    },
    setNotificationPermission(){
      if (Notification.permission === "granted") {
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          // console.log(permission);
        });
      }
    },
    showNotification(company, number) {
      const notification = new Notification("Nueva orden", {
        body: `${company} #${number}`,
        icon: "/logo_blue.png"
      });
      notification.onclick = (e) => {
        console.log('go somewhere');
      };
    }
  },
  async beforeMount() {
    if(window.innerWidth <= 400){
      this.isMobile = true;
    }
    this.setNotificationPermission();
    this.listenforNewOrders();
    const token = await firebase.auth().currentUser.getIdToken();
    // console.log(token);
  },
  watch: {
    orders: function (value) {
      if (value.length > 0) {
        this.threAreNoOrders = false;
      } else {
        this.threAreNoOrders = true;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
@import "src/assets/scss/invoice";
.orders-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.sub-container {
  display: inherit;
  flex-wrap: inherit;
  align-items: inherit;
}
.status-badge {
  display: inline-block;
  padding: 5px 8px !important;
  font-size: 75%;
  font-weight: normal !important;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 20px !important;
}
table > thead {
  text-transform: none !important;
}
#order-list-container{
  max-height: 70vh;
  overflow-y: auto;
}
.mobile-order-number{
  font-weight: 700;
}
.mobile-order-client 
,.mobile-order-branch-office{
  font-size: 0.9rem;
}
.mobile-order-total{
  font-size: 1.2rem;
}
.flex-col{
  display:flex;
  flex-direction:column;
}
@media screen and (max-height: 700px){
  #order-list-container{
    max-height: 62vh;
  }
}
</style>



